export default {"src":"/_next/static/media/assistant-rent.9a73407d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};